import ProfileContent from './profile-content';

export default ProfileContent;
